import { Product } from '../types';

/**
 * Checks if a product qualifies to be viewed on the Offers page:
 * - Product must not be in recycle bin and not unlisted
 * - AND:
 *   1. Explicitly assigned to the Offers page (showOnOffersPage === true)
 *   2. OR has a custom tag with text matching "New Offer" (case-insensitive)
 *   3. OR has "New Offer" in its tags array (case-insensitive)
 *   4. OR has its badge set to "New Offer" (case-insensitive)
 */
export function isProductAnOffer(p: Product): boolean {
  if (!p) return false;
  if (p.inRecycleBin === true || p.unlisted === true) return false;

  // 1. Explicitly assigned to Offers page
  if (p.showOnOffersPage === true) return true;

  // 2. Custom tag matching "New Offer"
  if (p.customTag?.text && p.customTag.text.trim().toLowerCase() === 'new offer') {
    return true;
  }
  if (Array.isArray(p.customTags) && p.customTags.some(t => t?.text && t.text.trim().toLowerCase() === 'new offer')) {
    return true;
  }

  // 3. Any tag in tags array matching "New Offer"
  if (Array.isArray(p.tags) && p.tags.some(t => typeof t === 'string' && t.trim().toLowerCase() === 'new offer')) {
    return true;
  }

  // 4. Badge matching "New Offer"
  if (p.badge && typeof p.badge === 'string' && p.badge.trim().toLowerCase() === 'new offer') {
    return true;
  }

  return false;
}
